var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h3',[_vm._v("TODO: Edit my profile...")]),_c('p',[_vm._v("@"+_vm._s(_vm.username)+" "+_vm._s(_vm.email)+", userid: "+_vm._s(_vm.id))]),_c('p',[_vm._v(" TODO: Oauth flow: facebook, twitter, instagram, linkedin ")])])}
var staticRenderFns = []

export { render, staticRenderFns }